import React from 'react';
import { useLocation } from 'react-router-dom';
import { SEO } from './SEO';
import seoConfig from '../config/seo-config';
import { absoluteUrl, normalizePath } from '../config/site';

export const RouteSEO = () => {
  const { pathname } = useLocation();
  const path = normalizePath(pathname);
  const config = seoConfig[path];

  // Routes without a config entry still get a self-referencing canonical and
  // the default title/description, so no page ships without meta.
  return (
    <SEO
      title={config?.title}
      description={config?.description}
      canonicalUrl={absoluteUrl(config?.canonicalPath || path)}
      noIndex={config?.noIndex}
    />
  );
};
